/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibMathRichErrorsV061,
  LibMathRichErrorsV061Interface,
} from "../LibMathRichErrorsV061";

const _abi = [
  {
    inputs: [],
    name: "DIVISION_BY_ZERO_ERROR",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DivisionByZeroError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "ROUNDING_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "numerator",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "denominator",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "target",
        type: "uint256",
      },
    ],
    name: "RoundingError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibMathRichErrorsV061__factory {
  static readonly abi = _abi;
  static createInterface(): LibMathRichErrorsV061Interface {
    return new utils.Interface(_abi) as LibMathRichErrorsV061Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibMathRichErrorsV061 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibMathRichErrorsV061;
  }
}
